import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    successContent: String,
    errorContent: String,
    fetchUrl: Boolean,
  };

  notify(message, type = "success") {
    if (type !== "success") {
      if (window.toastr) {
        window.toastr.error(message);
        return;
      }
      alert(message);
      return;
    }

    this.showCenteredModal(message);
  }

  showCenteredModal(message) {
    const existingModal = document.getElementById("clipboard-success-popup-modal");
    if (existingModal) {
      existingModal.remove();
    }

    const modalHtml = `
      <div class="modal fade" id="clipboard-success-popup-modal" tabindex="-1" aria-hidden="true" style="z-index: 1065;">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 440px;">
          <div class="modal-content border-0 shadow-lg text-center p-4" style="border-radius: 1rem;">
            <div class="modal-header border-0 pb-0 justify-content-end p-0">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body pt-0 pb-3 px-3">
              <div class="mb-3 d-inline-flex align-items-center justify-content-center rounded-circle" style="width: 64px; height: 64px; background-color: #d1e7dd;">
                <i class="fa-solid fa-check fs-2 text-success"></i>
              </div>
              <h5 class="fw-bold mb-2 text-dark">Link copiado!</h5>
              <p class="text-muted mb-0 small" style="line-height: 1.5;">${message}</p>
            </div>
            <div class="modal-footer border-0 pt-0 justify-content-center">
              <button type="button" class="btn btn-primary px-4 rounded-pill" data-bs-dismiss="modal">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHtml);
    const modalEl = document.getElementById("clipboard-success-popup-modal");

    const ModalClass = window.bootstrap?.Modal || (typeof bootstrap !== "undefined" && bootstrap.Modal);
    if (!ModalClass) {
      alert(message);
      return;
    }

    const modalInstance = new ModalClass(modalEl);
    modalInstance.show();

    let autoCloseTimer = setTimeout(() => {
      modalInstance.hide();
    }, 4000);

    modalEl.addEventListener("hidden.bs.modal", () => {
      clearTimeout(autoCloseTimer);
      modalEl.remove();
    }, { once: true });
  }

  async copy(event) {
    event.preventDefault();
    event.stopPropagation();

    const successMsg = this.successContentValue || "Link copiado para a área de transferência.";
    const errorMsg = this.errorContentValue || "Não foi possível copiar o link.";

    const fetchTextPromise = async () => {
      if (!this.fetchUrlValue) {
        return this.urlValue;
      }
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      const data = await response.text();
      if (data === "ERROR" || !response.ok) {
        throw new Error("Falha no servidor");
      }
      return data;
    };

    // Safari requires clipboard writing to stay within the direct user gesture stack.
    // If window.ClipboardItem exists, passing a Promise to ClipboardItem preserves user gesture.
    if (navigator.clipboard && window.ClipboardItem) {
      try {
        const textPromise = fetchTextPromise();
        const clipboardItem = new ClipboardItem({
          "text/plain": textPromise.then((text) => new Blob([text], { type: "text/plain" }))
        });
        await navigator.clipboard.write([clipboardItem]);
        this.notify(successMsg, "success");
        return;
      } catch (err) {
        console.warn("ClipboardItem write failed, trying fallback:", err);
      }
    }

    // Fallback: await fetch and try navigator.clipboard.writeText or execCommand('copy')
    try {
      const text = await fetchTextPromise();
      let copied = false;

      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          copied = true;
        } catch (_) {}
      }

      if (!copied) {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.top = "0";
        textarea.style.left = "0";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        copied = document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      if (copied) {
        this.notify(successMsg, "success");
      } else {
        this.notify(errorMsg, "error");
      }
    } catch (error) {
      console.error("Clipboard copy failed:", error);
      this.notify(errorMsg, "error");
    }
  }
}
